import { LegacyProxyRedirect } from '@/src/general/components/LegacyProxyRedirect'

export default () => <LegacyProxyRedirect proxyRedirectKey="intentions" />
